import { httpClient } from '@/services/http/httpClient'

type Params = {
  ideaId: string
  message: string
}

export async function recuseInvite({ ideaId, message }: Params) {
  await httpClient.post('/ideas/idea-users/reply-invite', {
    ideaId,
    message,
    action: 'REJECT',
  })
}
